import { useEffect, useState } from 'react';

import { daysInMs, getDiff, hoursInMs, isExpired, minutesInMs } from '../utils';

interface useCountdownParams {
  endDate: number;
}

const addPad = (value: number) => {
  const str = value.toString();
  return str.length < 2 ? `0${str}` : str;
};

const formatDate = (diff: number) => {
  const days = addPad(Math.floor(diff / daysInMs));
  const hours = addPad(Math.floor((diff % daysInMs) / hoursInMs));
  const minutes = addPad(Math.floor((diff % hoursInMs) / minutesInMs));
  const seconds = addPad(Math.floor((diff % minutesInMs) / 1000));

  return { days, hours, minutes, seconds };
};

export default function useCountdown({ endDate }: useCountdownParams) {
  const getInitialState = () => {
    if (isExpired(endDate))
      return {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      };

    return { ...formatDate(getDiff(endDate)) };
  };

  const [remainingTime, setRemainingTime] = useState<{
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
  } | null>(getInitialState());

  const updateTime = () => {
    if (isExpired(endDate)) return;
    const formatted = formatDate(getDiff(endDate));

    setRemainingTime({ ...formatted });
  };

  useEffect(() => {
    const interval = setInterval(() => updateTime(), 1000);

    return () => clearInterval(interval);
  }, []);

  return {
    ...remainingTime,
  };
}
